// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';

// shared
import {flashMessage} from 'shared/actions/notifications';

class ErrorMessageAndRedirect extends React.Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    redirectTo: PropTypes.string.isRequired,
    showError: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.props.showError();
  }

  render() {
    return (
      <Redirect path="*" to={this.props.redirectTo} />
    );
  }
}

const mapDispatchToProps = (dispatch, {message}) => ({
  showError: () => dispatch(flashMessage(message, 'error', {}, 5000))
});

export default connect(null, mapDispatchToProps)(ErrorMessageAndRedirect);
